import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import _ from "lodash";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Input from "../components/common/input";
import Select from "../components/common/select";
import Pagination from "../components/common/pagination";
import { paginate } from "../utils/paginate";
import http from "../services/http";
import Loading from "../components/common/loading";
import UserContext from "../context/userContext";

const ManageScreens = () => {
  const [user] = useContext(UserContext);

  const [screens, setScreens] = useState([]);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");
  const [access, setAccess] = useState([]);
  const [accessFilter, setAccessFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [parameter, setParameter] = useState("");
  const [searchedScreens, setSearchedScreens] = useState([]);
  const pageSize = 14;
  const navigation = '';
  
  useEffect(() => {
    document.title = "FTR - Manage Screens";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getScreens() {
      try {
        const { data } = await http.get(`/data-screens`);
        setScreens(data);
      }
      catch {
        //ignore error
      }

      setLoading(false);
    }

    async function getAccess() {
      try {
        const { data } = await http.get(`/data-access`);
        setAccess(data);
      }
      catch {
        //ignore error
      }
    }
    
    if (
      user) {
      getScreens();
      getAccess();
    }
  }, [user]);

  async function handleArchiveClick(screen) {
    const oldScreens = [...screens];
    setScreens(screens.filter((s) => s.ID !== screen.ID));
    try {
      await http.delete(`/data-screen/${screen.ID}`);
      toast.success("Screen Archived");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
      setScreens(oldScreens);
    }
  }

  async function handleExport() {
    const input = screens.map((s) => {
      return {
        id: s.ID,
        name: s.DESCRIPTION,
        type: s.SCREEN_TYPE === "DLY" ? "Daily" : "Hourly",
        access_level: s.ACCESS_LEVEL,
        last_updated: moment(s.LAST_UPDATED_DTS).format("DD-MMM-YY HH:mm"),
        updated_by: s.LAST_UPDATED_BY,
      };
    });
    try {
      const { data } = await http.post(`/csv`, { data: input });

      const options = {
        suggestedName: 'Screens.csv',
        types: [{
          description: "CSV file",
          accept: {'text/plain': ['.csv']}
        }]
      };

      const newHandle = await window.showSaveFilePicker(options);

      const writableStream = await newHandle.createWritable();
      await writableStream.write(data);
      await writableStream.close();

    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  async function handleParameterSearch(e) {
    e.preventDefault();

    if (parameter === "") return;
    try {
      const { data } = await http.get(`/data-screens/code/${parameter}`);
      setSearchedScreens(data);
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  async function handleDuplicate(screen) {
    // return toast.info("Coming Soon");
    try {
      const { data } = await http.post(`/data-screen/${screen.ID}`);
      setScreens((s) => _.sortBy([...s, data], ["DESCRIPTION"]));
      toast.success("Screen Duplicated");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  let filtered = [...screens];
  if (query)
    filtered = screens.filter((s) =>
      s.DESCRIPTION.toLowerCase().includes(query.toLowerCase())
    );
  if (accessFilter)
    filtered = filtered.filter(
      (s) => s.DATA_ACCESS_LEVEL === Number(accessFilter)
    );
  const pagedScreens = paginate(filtered, page, pageSize);
  return (
    <div className="col mt-4">
      <div className="row mt-3">
        <div className="col-auto">
          <Link to="/dataentry/manage/new">
            <button className="btn btn-primary">New</button>
          </Link>
        </div>
        <div className="col">
          <Input
            name="search-screens"
            placeholder="Search Screens"
            value={query}
            onChange={(e) => {
              setQuery(e.currentTarget.value);
              setPage(1);
            }}
          />
        </div>
        <div className="col">
          <Select
            name="access"
            placeholder="Filter Access"
            value={accessFilter}
            options={[{ ID: "" }, ...access]}
            onChange={(e) => setAccessFilter(e.currentTarget.value)}
            listKey="ID"
            listName="DESCRIPTION"
          />
        </div>
        <div className="col-auto">
          {!loading && (
            <button
              className="btn btn-outline-warning ml-auto mr-5"
              onClick={handleExport}
            >
              Export
            </button>
          )}
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
          <table className="table table-hover table-sm">
            <caption style={{ captionSide: "top", paddingBottom: 0 }}>
              {filtered.length} Screen{filtered.length === 1 ? "" : "s"}
            </caption>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Access Level</th>
                <th>Last Updated</th>
                <th>Updated By</th>
                {/* <th></th> */}
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {pagedScreens.map((screen) => (
                <tr key={screen.ID}>
                  <td>
                    <Link to={`/dataentry/manage/${screen.ID}`}>
                      {screen.DESCRIPTION}
                    </Link>
                  </td>
                  <td>
                    {screen.SCREEN_TYPE === "DLY" ? (
                      <span className="badge badge-primary">Daily</span>
                    ) : (
                      <span className="badge badge-success">Hourly</span>
                    )}
                  </td>
                  <td>{screen.ACCESS_LEVEL}</td>
                  <td>{moment.utc(screen.LAST_UPDATED_DTS).fromNow()}</td>
                  <td>{screen.LAST_UPDATED_BY}</td>
                  {/* <td>
                    <button className="btn btn-link">
                      <i className="far fa-star text-warning"></i>
                    </button>
                  </td> */}
                  <td>
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => handleDuplicate(screen)}
                    >
                      Duplicate
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleArchiveClick(screen)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            itemsCount={filtered.length}
            pageSize={pageSize}
            currentPage={page}
            onPageChange={(page) => setPage(page)}
            navigation={navigation}
          />
          <hr className="bg-success my-5" />
          <h3>Find by Parameter</h3>
          <form className="row mt-3">
            <div className="col">
              <Input
                name="parameter"
                placeholder="Parameter Code"
                value={parameter}
                onChange={(e) => setParameter(e.currentTarget.value)}
              />
            </div>
            <div className="col">
              <button
                className="btn btn-primary"
                onClick={handleParameterSearch}
              >
                Search
              </button>
            </div>
          </form>
          <div className="row mb-5">
            <div className="col">
              <table className="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Access Level</th>
                    <th>Last Updated</th>
                    <th>Updated By</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {searchedScreens.map((screen) => (
                    <tr key={screen.CODE}>
                      <td>
                        <Link to={`/dataentry/manage/${screen.CODE}`}>
                          {screen.DESCRIPTION}
                        </Link>
                      </td>
                      <td>
                        {screen.SCREEN_TYPE === "DLY" ? (
                          <span className="badge badge-primary">Daily</span>
                        ) : (
                          <span className="badge badge-success">Hourly</span>
                        )}
                      </td>
                      <td>{screen.ACCESS_LEVEL}</td>
                      <td>
                        {moment(screen.LAST_UPDATED_DTS).utc().calendar()}
                      </td>
                      <td>{screen.LAST_UPDATED_BY}</td>
                      <td>
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => toast.info("Coming Soon...")}
                        >
                          Duplicate
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleArchiveClick(screen)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ManageScreens;
